(function() {
    'use strict';

    angular.module('app.pilotos', []);
})();
